import { keyframes } from '@moonpig/launchpad-utils'
import { HOLD_FRACTION, ROW_HEIGHT } from './constants'

export const buildScrollKeyframes = (count: number) => {
  const percentPerStep = 100 / count

  const percentAt = (index: number) => index * percentPerStep
  const translateYAt = (index: number) => `translateY(-${index * ROW_HEIGHT}px)`

  const frames: string[] = [`0%{transform:${translateYAt(0)};}`]

  for (let index = 0; index < count; index += 1) {
    const stepStartPct = percentAt(index)
    const holdEndPct = stepStartPct + percentPerStep * HOLD_FRACTION
    const nextStepPct = percentAt(index + 1)

    frames.push(
      `${stepStartPct}%{transform:${translateYAt(index)};}`,
      `${holdEndPct}%{transform:${translateYAt(index)};}`,
      `${nextStepPct}%{transform:${translateYAt(index + 1)};}`,
    )
  }

  return keyframes`${frames.join('')}`
}
